import React from "react";
import { Redirect } from "react-router-dom";
import { Alert, Row, Col, Form, FormControl, Button } from "react-bootstrap";
import {
  fetchVolunteer,
  putVolunteer,
  postVolunteer,
  deleteVolunteer,
} from "./services/DataService";
import DeleteAlert from "./components/DeleteAlert";
import "./style/form.scss";

class AddVolunteer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onStatusChange = this.onStatusChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDeleteCallback = this.onDeleteCallback.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      fetchVolunteer(this.props.match.params.id).then((volunteer) =>
        this.setState({ ...volunteer })
      );
    }
  }

  onStatusChange(e) {
    this.setState({ status: e.target.value });
  }

  submitCallback() {
    this.setState({
      alert: (
        <Alert variant="secondary">
          <Alert.Heading>Submission Successful</Alert.Heading>
          <hr />
          <p>The volunteer has been added/updated.</p>
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => this.setState({ redirect: "/volunteers" })}
              variant="outline-secondary"
            >
              Close
            </Button>
          </div>
        </Alert>
      ),
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    this.setState({ validated: true });
    var isValid = form.checkValidity();
    const data = new FormData(event.target);
    let it = data.entries();
    let result = it.next();
    let volunteer = {};
    while (!result.done) {
      let key = result.value[0];
      let value = result.value[1];
      volunteer[key] = value;
      result = it.next();
    }
    if (isValid) {
      if (this.props.match.params.id) {
        volunteer.ID = parseInt(this.props.match.params.id, 10);
        putVolunteer(volunteer).then(this.submitCallback);
      } else {
        postVolunteer(volunteer).then(this.submitCallback);
      }
    }
  };

  onDelete() {
    this.setState({ deleteAlert: true });
  }

  onDeleteCallback() {
    this.setState({ deleteAlert: false, redirect: "/volunteers" });
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.alert) {
      return this.state.alert;
    }
    let deleteAlert;
    if (this.state.deleteAlert) {
      deleteAlert = (
        <DeleteAlert
          onConfirm={() => {
            deleteVolunteer(this.props.match.params.id).then(
              this.onDeleteCallback
            );
          }}
          onCancel={() => this.setState({ deleteAlert: false })}
        />
      );
    }
    let deleteButton;
    if (this.props.match.params.id) {
      deleteButton = (
        <div className="d-flex justify-content-center">
          <Button
            variant="danger"
            className="btn-delete"
            onClick={this.onDelete}
          >
            Delete
          </Button>
        </div>
      );
    }
    return (
      <div>
        {deleteAlert}
        <div className="form-title">
          {this.props.match.params.id ? "Edit" : "Add"} a Volunteer
        </div>
        <Form
          className="form"
          noValidate
          validated={this.state.validated}
          onSubmit={this.handleSubmit}
        >
          <Form.Group as={Row}>
            <Form.Label column sm="3">
              Username
            </Form.Label>
            <Col sm="9">
              <Form.Control
                required
                type="text"
                name="username"
                placeholder="vikingu"
                onChange={this.onChange}
                value={this.state.username || ""}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a username.
              </Form.Control.Feedback>
            </Col>
            <Form.Label column sm="3">
              W#
            </Form.Label>
            <Col sm="9">
              <Form.Control
                required
                type="text"
                name="wid"
                placeholder="W01234567"
                pattern="W[0-9]{8}"
                onChange={this.onChange}
                value={this.state.wid || ""}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid Western ID (ex W01234567).
              </Form.Control.Feedback>
            </Col>
            <Form.Label column sm="3">
              First Name
            </Form.Label>
            <Col sm="9">
              <Form.Control
                required
                type="text"
                name="first"
                placeholder="Anew"
                onChange={this.onChange}
                value={this.state.first || ""}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a first name.
              </Form.Control.Feedback>
            </Col>
            <Form.Label column sm="3">
              Last Name
            </Form.Label>
            <Col sm="9">
              <Form.Control
                required
                type="text"
                name="last"
                placeholder="Volunteer"
                onChange={this.onChange}
                value={this.state.last || ""}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a last name.
              </Form.Control.Feedback>
            </Col>
            <Form.Label column sm="3">
              Status
            </Form.Label>
            <Col sm="9">
              <FormControl
                required
                as="select"
                name="status"
                onChange={this.onStatusChange}
                value={this.state.status || "current"}
              >
                <option value="current" key="current">
                  Current
                </option>
                <option value="inactive" key="inactive">
                  Inactive
                </option>
              </FormControl>
            </Col>
          </Form.Group>
          <div className="d-flex justify-content-center">
            <div style={{ width: "95px" }}></div>
            <Button variant="primary" type="submit" className="btn-submit">
              {this.props.match.params.id ? "Update" : "Add"}
            </Button>
            {deleteButton}
          </div>
        </Form>
      </div>
    );
  }
}

export default AddVolunteer;
